module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.2e62b65.woff";